export default __webpack_public_path__ + "static/media/puzzle.cd416037.svg";